import React from 'react';
import { modules } from '../data/modules';
import { promises, systemIntro } from '../data/copy';
import { OFFER_ANCHOR, PRODUCT_ALT, PRODUCT_IMG, PRODUCT_NAME, PRODUCT_SUBTITLE, PRODUCT_TAGLINE } from './constants';
export function SystemSection() {
  return <section className="border-y border-pf-creamDark bg-pf-cream px-3 py-3 sm:px-4 sm:py-4" data-id="element-192" data-mp="36jshkm55ryq2">
      <div className="mx-auto max-w-4xl" data-id="element-193" data-mp="36m676fh2kiq8">
        <div className="mb-2 text-center" data-id="element-194" data-mp="31lqy403tlxe2">
          <p className="mb-0.5 font-display text-[10.5px] font-bold uppercase tracking-[0.16em] text-pf-coral sm:text-sm" data-id="element-195" data-mp="31mtp08157ztz">
            The Complete System You’ve Been Looking For
          </p>
          <h2 className="mb-1 font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-196" data-mp="2sqax8z4nehyz">
            One Complete 6-in-1 Prenatal Coaching System
          </h2>
          <div className="mb-1 inline-block rounded-md border border-pf-gold/70 bg-pf-navy px-3 py-1.5 shadow-md" data-id="element-197" data-mp="2itfz4hcaejl8">
            <p className="font-display text-[15px] font-extrabold uppercase leading-none tracking-tight text-white sm:text-2xl" data-id="element-198" data-mp="2dx7nhdxat8it">
              🤰 {PRODUCT_NAME}
            </p>
            <p className="font-display text-[10.5px] font-bold uppercase tracking-wide text-pf-gold sm:text-sm" data-id="element-199" data-mp="18rhj6dak10me">
              {PRODUCT_TAGLINE}
            </p>
            <p className="text-[10.5px] font-semibold text-white/80 sm:text-sm" data-id="element-200" data-mp="yzlhytd68udy">
              {PRODUCT_SUBTITLE}
            </p>
          </div>
          <div className="mx-auto max-w-3xl space-y-0.5 text-[12.5px] font-medium leading-snug text-pf-ink sm:text-base" data-id="element-201" data-mp="1mqh71iq8tbhi">
            {systemIntro.map(line => <p key={line} data-id="element-202" data-mp="1cqi0frddvv7a">{line}</p>)}
          </div>
          <ul className="mt-1 flex flex-wrap items-center justify-center gap-x-2.5 gap-y-0.5 text-[11px] font-bold text-pf-navy sm:text-sm" data-id="element-203" data-mp="1hqcqjspc4gra">
            {promises.map(promise => <li key={promise} data-id="element-204" data-mp="1epk9s5m0pwx">✔ {promise}</li>)}
          </ul>
        </div>

        <h3 className="mb-1.5 text-center font-display text-lg font-extrabold uppercase leading-tight tracking-tight sm:text-3xl" data-id="element-205" data-mp="69d072mjsbzw">
          What’s Inside
        </h3>
        <div className="grid gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-206" data-mp="240crcsvitcix">
          {modules.map(module => <a key={module.num} href={OFFER_ANCHOR} className="group flex gap-2 rounded-lg border border-pf-creamDark bg-white p-2.5 shadow-sm transition-colors duration-150 ease-out hover:border-pf-coral sm:p-3" data-id="element-207" data-mp="1z6qp7umzgr1d">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-pf-navy font-display text-base font-extrabold leading-none text-pf-gold transition-colors duration-150 ease-out group-hover:bg-pf-navyDeep" data-id="element-208" data-mp="1l8aja5wy34ka">
                {module.num}
              </span>
              <div className="min-w-0" data-id="element-209" data-mp="3an8dv8kc9pdg">
                <h4 className="font-display text-[13px] font-extrabold uppercase leading-tight text-pf-navy sm:text-base" data-id="element-210" data-mp="3amyj77ocmu1f">
                  ✅ Module {module.num} — {module.title}
                </h4>
                {module.lines.map(line => <p key={line} className="mt-0.5 text-[12px] font-medium leading-snug text-pf-ink sm:text-sm" data-id="element-211" data-mp="3i6py6o5eqjb2">
                    {line}
                  </p>)}
                {module.list && <ul className="mt-0.5 flex flex-wrap gap-x-1.5 text-[11.5px] font-semibold leading-snug text-pf-sage sm:text-[13px]" data-id="element-212" data-mp="3ryvmnnwgaili">
                    {module.list.map(item => <li key={item} data-id="element-213" data-mp="2z8dmaun42vbs">{item}</li>)}
                  </ul>}
                {module.close && <p className="mt-0.5 text-[12px] font-bold leading-snug text-pf-navy sm:text-sm" data-id="element-214" data-mp="396uh62p67u34">
                    {module.close}
                  </p>}
              </div>
            </a>)}
        </div>

        <div className="mt-2 text-center" data-id="element-215" data-mp="oer8fk5ix24g">
          <a href={OFFER_ANCHOR} className="inline-block" aria-label="Go to the purchase section" data-id="element-216" data-mp="m1fecwhnrxrs">
            <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[190px] object-contain drop-shadow-xl transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-217" data-mp="hztuusamcl8m" />
          </a>
        </div>
      </div>
    </section>;
}